import {Option} from ".//Option";
import {serialize} from "v8";

export class Day {
    private _selectedOptions: Set<Option> ;
    private _comment: string;

    constructor(selectedOptions: Set<Option> = new Set, comment: string = "") {
        this._selectedOptions = selectedOptions;
        this._comment = comment;
    }

    get comment(): string {
        return this._comment;
    }

    set comment(value: string) {
        this._comment = value;
    }

    get selectedOptions(): Set<Option> {
        return this._selectedOptions;
    }

    set selectedOptions(value: Set<Option>) {
        this._selectedOptions = value;
    }

    set addOption( value: Option) {
        this._selectedOptions.add(value);
    }

    set removeOption( value: Option ) {
        this._selectedOptions.delete(value);
    }

    public serialize(): string {

        const selectedOptions = Array.from(this._selectedOptions);

        return JSON.stringify({

            comment: this._comment,
            selectedOptions: selectedOptions.map((selectedOption) => selectedOption.serialize()),

        });

    }

    static parse(dayString: string): Day {

        const serializedDay = JSON.parse(dayString);

        const comment = serializedDay['comment'];
        const options = serializedDay['selectedOptions'].map((selectedOption: any) => {

            return Option.parse(selectedOption);

        });


        return new Day(new Set<Option>(options), comment);
    }

    // public parse(dayString: string): Day {
    //
    //     const dayJSON = JSON.parse(dayString);
    //
    //
    // }

}